var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, Typography, Link } from '@one-thd/sui-atomic-components';
import { FooterButtons } from '../footer-buttons';
import { getTextFieldStatus } from '../../../../utils/form';
import { useManageUserForm } from '../../../../hooks/use-manage-user-form';
export var UserDetailsSection = function (_a) {
    var isActive = _a.isActive, isCompleted = _a.isCompleted, continueHandler = _a.continueHandler, editHandler = _a.editHandler, cancelHandler = _a.cancelHandler;
    var formMethods = useManageUserForm().formMethods;
    var control = formMethods.control, getValues = formMethods.getValues, trigger = formMethods.trigger;
    var firstName = getValues('firstName');
    var lastName = getValues('lastName');
    var email = getValues('email');
    var userName = "".concat(firstName, " ").concat(lastName);
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8 sui-mb-4" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                React.createElement(Typography, { variant: "h5" }, "User Details"),
                isCompleted && (React.createElement(Link, { "data-testid": "details-edit-btn", onClick: function () {
                        editHandler();
                    } }, "Edit"))),
            !isActive && userName && email && (React.createElement("div", null,
                React.createElement(Typography, null,
                    React.createElement("span", { className: "sui-capitalize" }, userName)),
                React.createElement(Typography, null, email))),
            isActive && (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(Controller, { name: "firstName", control: control, render: function (_a) {
                        var _b;
                        var field = _a.field, errors = _a.formState.errors;
                        var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                        var status = getTextFieldStatus(errors.firstName);
                        return (React.createElement(TextField, { fullWidth: true, label: "First Name*", id: "firstName", value: value, name: name, status: status, statusMessage: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message, onChange: onChange, InputProps: {
                                inputProps: __assign(__assign({}, rest), { 'data-testid': 'first-name-inpt' }),
                            } }));
                    } }),
                React.createElement(Controller, { name: "lastName", control: control, render: function (_a) {
                        var _b;
                        var field = _a.field, errors = _a.formState.errors;
                        var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                        var status = getTextFieldStatus(errors.lastName);
                        return (React.createElement(TextField, { fullWidth: true, label: "Last Name*", id: "lastName", value: value, status: status, statusMessage: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message, name: name, onChange: onChange, InputProps: {
                                inputProps: __assign(__assign({}, rest), { 'data-testid': 'last-name-inpt' }),
                            } }));
                    } }),
                React.createElement(Controller, { name: "email", control: control, render: function (_a) {
                        var _b;
                        var field = _a.field, errors = _a.formState.errors;
                        var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                        var status = getTextFieldStatus(errors.email);
                        return (React.createElement(TextField, { fullWidth: true, label: "Email*", status: status, statusMessage: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message, id: "email", name: name, value: value, onChange: onChange, InputProps: {
                                inputProps: __assign(__assign({}, rest), { 'data-testid': 'email-inpt' }),
                            } }));
                    } }),
                React.createElement("div", { className: "sui-mt-4 sui-mb-4" },
                    React.createElement(FooterButtons, { continueText: "Continue", continueHandler: function () {
                            trigger(['firstName', 'lastName', 'email']).then(function (passed) {
                                if (passed) {
                                    continueHandler();
                                }
                            });
                        }, cancelHandler: cancelHandler })))))));
};
